export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Potwierdzenie", larga: "Potwierdzenie rezerwacji", porque: "Używane jest ustawienie z poziomu konta, a nie ustawienie właściwe dla tego obiektu." },
    bienvenida: { etiqueta: "Powitanie", larga: "Wiadomość powitalna", porque: "W tej chwili wysyłana jest domyślna wiadomość powitalna, a nie Pana/Pani własna." },
    checkin: { etiqueta: "Check-in", larga: "Wysyłka check-in", porque: "W tej chwili wysyłka odbywa się o domyślnej godzinie, która może Panu/Pani nie odpowiadać." },
    horas: { etiqueta: "Godziny", larga: "Godziny check-in i check-out", porque: "Bez Pana/Pani godzin goście, którzy o nie zapytają, otrzymają godziny domyślne." },
    cerradura: { etiqueta: "Dostęp", larga: "Zamek i dostęp", porque: "Gość dociera pod drzwi, nie wiedząc, jak je otworzyć." },
    servicios: { etiqueta: "Usługi", larga: "Usługi w obiekcie", porque: "Ani silnik rezerwacji, ani agent nie wie, co Pan/Pani oferuje." },
    politicas: { etiqueta: "Zasady", larga: "Polityki i zasady", porque: "Gość akceptuje zasady domyślne, a nie Pana/Pani własne." },
  },
  titular: {
    listo: "Wszystko gotowe",
    unoAMedias: "Obiekt jest skonfigurowany tylko w połowie",
    variosAMedias: "Obiekty są skonfigurowane tylko w połowie",
    casi: "Już prawie gotowe",
  },
  consecuencia: {
    bienvenida: "Tymczasem goście otrzymują domyślną wiadomość powitalną, a nie Pana/Pani własną.",
    cerradura: "Tymczasem część gości dotarłaby pod drzwi, nie wiedząc, jak je otworzyć.",
    politicas: "Tymczasem goście akceptują zasady domyślne, a nie Pana/Pani własne.",
    generico: "Tymczasem używane są ustawienia domyślne, a nie Pana/Pani własne.",
  },
  explicacion: {
    listoUno: "Obiekt może już przyjmować gości.",
    listoVarios: "Wszystkie obiekty ({n}) mogą już przyjmować gości.",
    ajustesFinos: "Drobniejsze ustawienia, czyli ceny, kanały i atrakcje, czekają w każdej ofercie, gdy tylko będą potrzebne.",
    faltaUno: "Został jeszcze 1 obiekt do dokończenia.",
    faltanVarios: "Obiekty pozostałe do dokończenia: {n}.",
  },
  resumen: {
    unAlojamiento: "1 obiekt",
    nAlojamientos: "Obiekty: {n}",
    unoPorPreparar: "1 do skonfigurowania",
    nPorPreparar: "Do skonfigurowania: {n}",
    listos: "Gotowe: {listos}",
  },
  anillo: {
    rotulo: "skonfigurowano",
    ariaCorta: "Skonfigurowano {n}%",
    ariaLarga: "Ukończono {n}% konfiguracji",
  },
  cifras: {
    listos: "gotowe ·",
    ajustes: "ustawień gotowych",
    ariaAjustes: "Gotowe ustawienia: {hechas} z {total}",
    marcador: "{hechas} z {total}",
  },
  ventana: {
    titulo: "Zamknąć to powiadomienie?",
    texto: "Przestanie pojawiać się w panelu, nawet jeśli coś pozostanie nieskonfigurowane.",
    notaAntes: "Można je przywrócić w każdej chwili w",
    notaRuta: "Personalizacja → Pokaż powiadomienie o konfiguracji",
    cancelar: "Anuluj",
    ocultar: "Zamknij",
  },
  acciones: {
    verQueFalta: "Zobacz, czego brakuje",
    buscar: "Szukaj obiektu",
    sinResultados: "Żaden oczekujący obiekt tak się nie nazywa.",
    verClaro: "Przełącz na jasny",
    verOscuro: "Przełącz na ciemny",
    ampliar: "Rozwiń",
    ampliarAria: "Rozwiń powiadomienie",
    minimizar: "Zminimalizuj",
    minimizarAria: "Zminimalizuj powiadomienie",
    entendido: "Rozumiem",
    entendidoAria: "Rozumiem, zamknij powiadomienie",
    ocultar: "Zamknij",
    ocultarAria: "Zamknij powiadomienie o konfiguracji",
    empezar: "Zacznij",
    continuar: "Kontynuuj",
    hecho: "gotowe",
    teToca: "Następny krok:",
    unidades: "Jednostki: {n}",
  },
};
